import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import { equals } from "ramda";
import { Select } from "@interdependence-ui";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];
var sortOptions = {
  unsorted: "Ingen sortering",
  alpha: "Från A till Ö",
  reverseAlpha: "Från Ö till A",
  desc: "Fallande",
  asc: "Stigande"
};
export default /*#__PURE__*/memo(function SelectDataSort(props) {
  var selected = props.selected,
    _onChange = props.onChange,
    includedSort = props.includedSort;
  var sortKeys = Object.keys(sortOptions);
  var options = sortKeys.filter(function (x) {
    return includedSort.includes(x);
  }).map(function (x) {
    return {
      id: x,
      label: sortOptions[x]
    };
  });
  return /*#__PURE__*/_jsx(Select, _objectSpread({
    id: "select-datasort",
    label: "V\xE4lj sortering",
    hideLabel: true,
    _selected: options.findIndex(function (option) {
      return equals(option.id, selected);
    }),
    options: options,
    onChange: function onChange(idx) {
      var _options$idx;
      return _onChange((_options$idx = options[idx]) === null || _options$idx === void 0 ? void 0 : _options$idx.id);
    }
  }, extendedSystemStylesProps(styledSystemKeys, props)), options);
}, function (curr, prev) {
  return equals(curr.selected, prev.selected) && equals(curr.includedSort, prev.includedSort);
});